import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useEventVenueDialogTelemetry } from '../components/EventVenueDialog/EventVenueDialog.telemetry';
import { EventVenueState } from '../components/EventVenueDialog/useEventVenueDialog';
import { VenueDialogAction } from './useEventVenueDialogReducer';
import { useEventInfo } from '@shared/utils/eventInfo';

export const useVenueDialogTransitions = (dispatch: React.Dispatch<VenueDialogAction>) => {
  const { eventHandle } = useEventInfo();
  const telemetry = useEventVenueDialogTelemetry();

  const callTelemetry = useEventCallback((eventVenueState: EventVenueState) => {
    telemetry.eventVenueDialogStateChanged(eventVenueState, eventHandle);
  });

  const goToCreate = useEventCallback(() => {
    callTelemetry('create');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'create' });
  });

  const goToUpdate = useEventCallback(() => {
    callTelemetry('update');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'update' });
  });

  const goToIntro = useEventCallback(() => {
    callTelemetry('intro');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'intro' });
  });

  const goToFilters = useEventCallback(() => {
    callTelemetry('filters');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'filters' });
  });

  const goToHotels = useEventCallback(() => {
    callTelemetry('hotels');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'hotels' });
  });

  const goToNoHotels = useEventCallback(() => {
    callTelemetry('noHotels');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'noHotels' });
  });

  const goToError = useEventCallback(() => {
    callTelemetry('error');
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: 'error' });
  });

  return { goToCreate, goToUpdate, goToIntro, goToFilters, goToHotels, goToError, goToNoHotels };
};
